import {
  afterNextRender,
  Component,
  computed,
  DestroyRef,
  inject,
  input,
  signal,
} from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { TranslocoDirective } from '@jsverse/transloco';

interface NavLink {
  labelKey: string;
  path: string;
}

@Component({
  imports: [RouterLink, RouterLinkActive, TranslocoDirective],
  selector: 'app-navbar',
  styleUrl: './navbar.css',
  templateUrl: './navbar.html',
})
export class Navbar {
  /** Start transparent with no bottom border, turning solid once the page scrolls. */
  readonly overlay = input(false);

  private readonly destroyRef = inject(DestroyRef);
  private readonly scrolled = signal(false);

  /** Solid (bordered, blurred background) whenever not in overlay mode, or once scrolled. */
  protected readonly solid = computed(() => !this.overlay() || this.scrolled());

  constructor() {
    afterNextRender(() => {
      const update = () => this.scrolled.set(window.scrollY > 8);
      update();
      window.addEventListener('scroll', update, { passive: true });
      this.destroyRef.onDestroy(() => window.removeEventListener('scroll', update));
    });
  }

  protected readonly links: NavLink[] = [
    // { labelKey: 'nav.programmes', path: '/programmes' },
  ];

  protected readonly menuOpen = signal(false);

  // Toggle the menu open/closed state.
  protected toggleMenu(): void {
    this.menuOpen.update((open) => !open);
  }

  // Close the menu.
  protected closeMenu(): void {
    this.menuOpen.set(false);
  }
}
